import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../Myaddvertisements/Myaddvertisements.css";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import placeholder from "../../assets/placeholder.jpg";

export default function Myaddvertisements() {
  const [items, setItems] = useState([]);

  // useEffect(() => {
    
  //   axios
  //     .get(BaseUrl + BuyerServicesUrl.ShowAdvertisements,  {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             console.log("TOKEN:", token);

  //         },
  //       })
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setItems(res.data.data);
  //       }
  //     })
  //     .catch((err) => console.error(err));
  // }, []);
// useEffect(() => {
//   const token = localStorage.getItem("token");
//   console.log("TOKEN:", token);
// const token = localStorage.getItem("token");

// const response = await axios.post(
//   BaseUrl + BuyerServicesUrl.AddAdvertisement,
//   formData,
//   {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       // سيبي Content-Type للمتصفح مع FormData
//     },
//   }
// );

// console.log("CREATE-AD RESPONSE:", response.data);

//   axios
//     .get(BaseUrl + BuyerServicesUrl.ShowAdvertisements, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     })
//     .then((res) => {
//       console.log("RESPONSE:", res.data);
//       setItems(res.data.data || []);
//     })
//     .catch((err) => console.error(err));
// }, []);

useEffect(() => {
  const token = localStorage.getItem("token");

  axios
    .get(BaseUrl + BuyerServicesUrl.ShowAdvertisements, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log("MY ADS RESPONSE:", res.data);
      setItems(res.data.data || []);
      
    })
    .catch((err) => console.error(err));
    
}, []);

  return (
    <div className="sellerrelated-section m-auto pb-5 pt-4">
      <div className="related-header mb-5 pb-5">
        {/* Optional header */}
      </div>

      <div className="related-cards mb-5">
          {items.length === 0 && (
    <h2 className="text-center mt-5">لا يوجد إعلانات حالياً</h2>
  )}

        {items.map((item, index) => {
          console.log("ITEMS:", items);
let link = `/advertisementdetails/${item.id}`;
          return (
            <Link
               to={`/advertisementdetails/${item.id}`}
              className="related-card"
              key={item.id}
            >

              
              {/* <img src={item.image[0]} alt={item.name} /> */}
              {/* <img
  src={
    Array.isArray(item.image)
      ? item.image[0]
      : item.image || placeholder
  }
  alt={item.name}
/> */}
{/* <img
  src={
    Array.isArray(item.image) && item.image.length > 0
      ? item.image[0]
      : item.image && item.image !== "null" && item.image !== "undefined"
      ? item.image
      : placeholder
  }
  alt={item.name}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = placeholder;
  }}
/> */}
<img
  src={
    Array.isArray(item.image) && item.image.length > 0
      ? item.image[0].url
      : placeholder
  }
  alt={item.name}
/>

              <h4>{item.name}</h4>
              <p className="desc">{item.description}</p>
              <p className="price">
                {item.priceAfterDiscount
                  ? `${item.price} ر.س`
                  : `${item.price} ر.س`}
              </p>
            </Link>
            
          );
        })}
      </div>
    </div>
  );
}
